import { Outlet } from 'react-router-dom';
import Header from '../layout/Header/Header';
import Footer from '../layout/Footer/Footer';

export default function AdminLayout() {
    return (
        <div className="min-h-screen flex flex-col justify-between bg-gray-100">
            <Header />
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="mx-auto w-full sm:w-[90%] md:w-[80%]">
                    <Outlet />
                </div>
            </main>
            <Footer />
        </div>
    );
}